import { Link } from 'react-router-dom';

export default function ArticleTeaserSection() {
  const guides = [
    {
      to: '/article/superbuy-spreadsheet-for-sneakerheads',
      badge: 'Sneaker Guide',
      title: 'Superbuy Spreadsheet for Sneakerheads',
      desc: 'Track releases, compare sellers, and build your ultimate sneaker collection.',
      icon: 'ri-footprint-line',
    },
    {
      to: '/article/track-qc-photos-superbuy-sheet',
      badge: 'QC Tutorial',
      title: 'How to Track QC Photos in Your Sheet',
      desc: 'Master quality control inspection with structured checklists and photo organization.',
      icon: 'ri-image-line',
    },
    {
      to: '/article/superbuy-spreadsheet-pricing-budget-guide',
      badge: 'Budget Guide',
      title: 'Pricing & Budget Tracking Guide',
      desc: 'Handle currency conversion, shipping math, and never overspend on a haul again.',
      icon: 'ri-money-dollar-circle-line',
    },
  ];

  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-20">
          <div className="flex-1 w-full">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full bg-foreground-950" />
              <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-wider">Guides & Resources</span>
            </div>

            <blockquote className="mb-8">
              <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-medium text-foreground-950 leading-snug">
                &ldquo;Master your cross-border shopping workflow with our in-depth guides, from setup to advanced automation.&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-accent-600 font-bold text-sm">SS</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">Superbuy Team</p>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <i className="ri-verified-badge-fill text-accent-500 text-xs" />
                  <span className="text-xs text-foreground-400">Verified Shopping Expert</span>
                </div>
              </div>
            </div>

            <Link
              to="/article/superbuy-spreadsheet-ultimate-guide"
              className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
            >
              Read Ultimate Guide
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="flex-1 w-full space-y-4">
            {guides.map((guide) => (
              <Link
                key={guide.to}
                to={guide.to}
                className="block group bg-background-100 hover:bg-background-50 rounded-2xl p-5 transition-all duration-200 border border-transparent hover:border-background-200 cursor-pointer"
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-white group-hover:bg-accent-50 transition-colors duration-200">
                    <i className={`${guide.icon} text-foreground-600 group-hover:text-accent-600 text-lg transition-colors duration-200`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="inline-block text-[10px] font-semibold uppercase tracking-wider text-foreground-400 mb-1">{guide.badge}</span>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-0.5 group-hover:text-foreground-950 transition-colors">{guide.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{guide.desc}</p>
                  </div>
                  <div className="flex-shrink-0 flex items-center pt-2">
                    <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-foreground-600 text-lg transition-all duration-200 group-hover:translate-x-0.5" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}